import RadioSelect from 'edge/platform/widgets/radioselect/components/radioSelect/RadioSelect';
import RadioSelectImage from 'edge/platform/widgets/radioselect/components/radioSelectImage/RadioSelectImage';

export default angular.module('edge.platform.widgets.radioselect', [])
    .component('gwRadioSelect', RadioSelect)
    .component('gwRadioSelectImage', RadioSelectImage);